import { withErrorBoundary } from "@sentry/nextjs";
import { CSSProperties, FC } from "react";
import { twMerge } from "tailwind-merge";
import { Image } from "./Image/Image";
interface TagProps {
  bgColor?: string;
  label: string;
  iconUrlHash?: string;
  iconAlt?: string;
  className?: string;
}

const Tag: FC<TagProps> = withErrorBoundary(
  ({ bgColor = "var(--theme-ui-colors-dusk-10)", label, iconUrlHash = "", iconAlt = "", className = "" }) => {
    return (
      <div
        style={
          {
            "--tag-background-color": bgColor,
          } as CSSProperties
        }
      >
        <div
          className={twMerge(
            "flex gap-0.5 text-nowrap rounded bg-[--tag-background-color] px-2 text-sm font-semibold",
            className
          )}
        >
          {iconUrlHash && (
            <Image
              src={iconUrlHash}
              alt={iconAlt}
              width={20}
              height={20}
              className="-ml-1 h-[1em] self-center fill-inherit"
            />
          )}
          {label}
        </div>
      </div>
    );
  },
  {}
);

export { Tag };
